import events from '../../../actions/event-names';
import Config from '../../../config';
import { showError, showSuccess } from '../../../utils'

const initialState = {
    isListFetchCompleted: false,
    isListFetched: false,
    recipeList: [],
    isDetailsFetched: false,
    recipeDetails: "",
    recipeCategories: [],
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
 
    //   LIST
    case `${events.GET_RECIPE_LIST}_PENDING`: {
        if(action.meta.page === 0) {
            state.recipeList = [];
        }
        return {
            ...state,
            isListFetched: 'PENDING',
        };
    }
    case `${events.GET_RECIPE_LIST}_FULFILLED`: {
        if(action.payload.data.length === 0) {
            state.isListFetchCompleted = true;
        }
        return {
            ...state,
            recipeList: [...state.recipeList, ...action.payload.data],
            isListFetched: 'FULFILLED',
        };
    }
    case `${events.GET_RECIPE_LIST}_REJECTED`: {
        return {
            ...state,
            isListFetched: 'REJECTED',
        };
    }


    //   DETAILS
    case `${events.GET_RECIPE_DETAILS}_PENDING`: {
        return {
            ...state,
            recipeDetails: "",
            isDetailsFetched: 'PENDING',
        };
    }
    case `${events.GET_RECIPE_DETAILS_BG}_FULFILLED`: 
    case `${events.GET_RECIPE_DETAILS}_FULFILLED`: {
        return {
            ...state,
            recipeDetails: action.payload.data,
            isDetailsFetched: 'FULFILLED',
        };
    }
    case `${events.GET_RECIPE_DETAILS}_REJECTED`: {
        return {
            ...state,
            isDetailsFetched: 'REJECTED',
        };
    }


    //  DETAILS SAVE
    case `${events.SAVE_RECIPE_TRANSLATIONS}_PENDING`:
    case `${events.SAVE_RECIPE_DETAILS}_PENDING`: {
        return {
            ...state,
            saverecipeDetails: 'PENDING',
        };
    }
    case `${events.SAVE_RECIPE_TRANSLATIONS}_FULFILLED`:
    case `${events.SAVE_RECIPE_DETAILS}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            saverecipeDetails: 'FULFILLED',
        };
    }
    case `${events.SAVE_RECIPE_TRANSLATIONS}_REJECTED`:
    case `${events.SAVE_RECIPE_DETAILS}_REJECTED`: {
        return {
            ...state,
            saverecipeDetails: 'REJECTED',
        };
    }

  

    case `${events.ADD_NEW_RECIPE}_PENDING`: {
        return {
            ...state,
            isNewrecipeAdded: 'PENDING',
        };
    }
    case `${events.ADD_NEW_RECIPE}_FULFILLED`: {
        showSuccess("New recipe added successfully")
        return {
            ...state,
            isNewrecipeAdded: 'FULFILLED',
        };
    }
    case `${events.ADD_NEW_RECIPE}_REJECTED`: {
        return {
            ...state,
            isNewrecipeAdded: 'REJECTED',
        };
    }


    case `${events.DELETE_RECIPE}_PENDING`: {
        return {
            ...state,
            isrecipeDeleted: 'PENDING',
        };
    }
    case `${events.DELETE_RECIPE}_FULFILLED`: {
        showSuccess("Recipe deleted successfully")
        return {
            ...state,
            isrecipeDeleted: 'FULFILLED',
        };
    }
    case `${events.DELETE_RECIPE}_REJECTED`: {
        return {
            ...state,
            isrecipeDeleted: 'REJECTED',
        };
    }


    case `${events.GET_RECIPE_CATEGORIES}_PENDING`: {
        return {
            ...state,
        };
    }
    case `${events.GET_RECIPE_CATEGORIES}_FULFILLED`: {
        return {
            ...state,
            recipeCategories: [...action.payload.data.recipe_categories.map((v) => {
                return{
                    label: v,
                    value: v,
                }
            })],
        };
    }
    case `${events.GET_RECIPE_CATEGORIES}_REJECTED`: {
        return {
            ...state,
        };
    }


    default:
        return state;
    }
}
